module.exports = __webpack_public_path__ + "img/view_icon.c5eacb84.svg";